import { styled } from '@mui/system';
import { Box } from '@mui/material';
import styledSC, { css, keyframes } from 'styled-components';

export const Container = styled('div')`
min-height: 100vh;
`

export const SecondRowContainer = styled(Box)({
    maxWidth: '80vw', // Default width for desktop

    // Center the container on desktop
    margin: '0 auto',

    // Media query for screens with a maximum width of 600px (adjust as needed)
    '@media (max-width: 900px)': {
        maxWidth: '100%', // Set width to 100% for smaller screens
    },
});

// Modern Profile Form styled components
export const ProfileCard = styledSC.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    padding: 20px;
    border-radius: 12px;
  }
`;

export const ProfileHeader = styledSC.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #E5E5E5;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }
`;

export const AvatarContainer = styledSC.div`
  position: relative;
  width: 100px;
  height: 100px;
  flex-shrink: 0;
`;

export const ProfileAvatar = styledSC.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #F5F5F5;
`;

export const AvatarEditButton = styledSC.button`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #FF9F1C;
  color: white;
  border: 3px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 200ms ease;
  
  &:hover {
    background: #E68A00;
    transform: scale(1.1);
  }
`;

export const ProfileInfo = styledSC.div`
  flex: 1;
`;

export const ProfileName = styledSC.h1`
  font-size: 24px;
  font-weight: 600;
  color: #171717;
  margin: 0 0 4px 0;
`;

export const ProfileEmail = styledSC.p`
  font-size: 14px;
  color: #737373;
  margin: 0;
`;

export const FormGrid = styledSC.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const FormGroup = styledSC.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  
  ${props => props.fullWidth && css`
    grid-column: 1 / -1;
  `}
`;

export const FormLabel = styledSC.label`
  font-size: 14px;
  font-weight: 500;
  color: #404040;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const SaveButton = styledSC.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: #FF9F1C;
  color: white;
  font-weight: 600;
  font-size: 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 200ms ease;
  min-width: 140px;
  
  &:hover:not(:disabled) {
    background: #E68A00;
    transform: translateY(-2px);
    box-shadow: 0 8px 12px -3px rgba(255, 159, 28, 0.3);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  ${props => props.isLoading && css`
    &::before {
      content: '';
      width: 16px;
      height: 16px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-top-color: white;
      border-radius: 50%;
      animation: ${spin} 0.8s linear infinite;
    }
  `}
`;

export const FormActions = styledSC.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #E5E5E5;
`;

export const SecondaryButton = styledSC.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  background: white;
  color: #404040;
  font-weight: 500;
  font-size: 15px;
  border: 1px solid #E5E5E5;
  border-radius: 10px;
  cursor: pointer;
  transition: all 200ms ease;
  
  &:hover {
    background: #F5F5F5;
    border-color: #D4D4D4;
  }
`;

export const SectionTitle = styledSC.h2`
  font-size: 18px;
  font-weight: 600;
  color: #171717;
  margin: 0 0 20px 0;
`;
